/*
 * Client-side content for /pages/* handles that do not exist as Shopify pages.
 * Shopify serves a 404 for these routes; we replace #main with the real content.
 * Rendered into a .arc-doc wrapper, which is centred by CSS (category.css).
 */
(function () {
  var path = window.location.pathname.replace(/\/+$/, '');
  var match = path.match(/^\/pages\/([\w-]+)$/);
  if (!match) return;

  var EMAIL = 'arcjewells@gmail.com';
  var PHONE = '+91 96501 93560';
  var PHONE_HREF = '+919650193560';
  var RETURN_DAYS = 3;

  var mail = '<a href="mailto:' + EMAIL + '">' + EMAIL + '</a>';
  var tel = '<a href="tel:' + PHONE_HREF + '">' + PHONE + '</a>';

  /* ---------- markup helpers ---------- */

  function crumb(label) {
    return '<nav class="pdp-crumb"><a href="/">Home</a> / <span>' + label + '</span></nav>';
  }

  function head(eyebrow, title, lede) {
    return '<header class="arc-doc-head">' +
      '<span class="arc-doc-eyebrow">' + eyebrow + '</span>' +
      '<h1>' + title + '</h1>' +
      (lede ? '<p class="arc-doc-lede">' + lede + '</p>' : '') +
      '<div class="arc-doc-rule"></div>' +
      '</header>';
  }

  function faq(items) {
    return items.map(function (it) {
      if (it.group) return '<p class="arc-faq-group">' + it.group + '</p>';
      return '<details>' +
        '<summary>' + it.q + '</summary>' +
        '<div class="arc-faq-a">' + it.a + '</div>' +
        '</details>';
    }).join('');
  }

  function facts(rows) {
    return '<div class="arc-facts">' + rows.map(function (r) {
      return '<div><span class="k">' + r[0] + '</span><span class="v">' + r[1] + '</span></div>';
    }).join('') + '</div>';
  }

  function steps(items) {
    return '<ol class="arc-steps">' + items.map(function (s) {
      return '<li><strong>' + s[0] + '</strong>' + s[1] + '</li>';
    }).join('') + '</ol>';
  }

  function foot(lines, sign) {
    return '<footer class="arc-doc-foot">' +
      lines.map(function (l) { return '<p>' + l + '</p>'; }).join('') +
      (sign ? '<p class="arc-doc-sign">' + sign + '</p>' : '') +
      '</footer>';
  }

  /* ---------- pages ---------- */

  var pages = {};

  /* ============================ CARE GUIDE ============================ */
  pages['care-guide'] = {
    title: 'Jewellery Care Guide',
    html:
      crumb('Care Guide') +
      head(
        'Look after it',
        'Jewellery Care Guide',
        'Every ARC piece is crafted with a premium anti-tarnish, water-resistant finish. It is built for real, everyday life — and with a few simple habits, it will keep its shine for years.'
      ) +
      '<div class="arc-doc-body">' +

      '<p>Jewellery lives a hard life. It meets perfume in the morning, hand sanitiser at lunch, sweat on the commute and a tangled corner of a bag at night. Our anti-tarnish plating is designed to take all of that in its stride, but plating is a surface — and every surface responds to how it is treated.</p>' +
      '<p>This guide covers everything worth knowing, from the sixty-second habits that matter most to the small details that keep a piece looking new in its third year. None of it is complicated.</p>' +

      '<div class="arc-note">' +
      '<p><strong>The short version:</strong> put your jewellery on last and take it off first. Keep it dry where you can, wipe it after wearing, and store pieces separately. That is roughly 90% of jewellery care.</p>' +
      '</div>' +

      '<h2>The Daily Habits</h2>' +

      '<h3>Wear it last, remove it first</h3>' +
      '<p>Perfume, lotion, sunscreen, hairspray, makeup and deodorant are the single biggest cause of dulled plating. Each one leaves a fine chemical film that builds up in the crevices of a setting and slowly clouds the finish.</p>' +
      '<p>So make your jewellery the final step of getting ready — after your fragrance has dried and your hair is done. At the end of the day, take it off before you remove makeup or wash your face. This one habit does more than any cleaning routine.</p>' +

      '<h3>Give it a wipe after every wear</h3>' +
      '<p>Skin produces oils and salts all day, and they are mildly acidic. Left overnight on metal, they etch. A five-second wipe with a soft, dry microfiber or cotton cloth lifts them away before they can do anything.</p>' +
      '<p>Wipe gently, in straight strokes rather than hard circles, and pay attention to the back of pendants and the inside of rings — the parts that sit against skin are the parts that need it most.</p>' +

      '<h3>Take it off for the rough stuff</h3>' +
      '<p>Remove your jewellery before the gym, swimming, gardening, cleaning, cooking with acidic ingredients, or sleeping. Chlorine and saltwater are particularly unkind to plated finishes, and sleeping in earrings or chains is the most common way pieces get bent or snapped.</p>' +

      '<h2>Water, Chemicals and Heat</h2>' +

      '<h3>Water resistance, honestly explained</h3>' +
      '<p>Every ARC piece is water-resistant — a splash at the sink, getting caught in the rain, or washing your hands with your rings on will not harm it. That is exactly what the finish is designed for.</p>' +
      '<p>What we would avoid is <strong>prolonged, repeated</strong> immersion: long showers, swimming pools, hot tubs and the sea. Water on its own is fairly harmless; it is what is dissolved in it — chlorine, salt, soap, minerals in hard water — that gradually works at the plating. Water resistance means your jewellery survives accidents. It does not mean it should live underwater.</p>' +

      '<h3>Chemicals to keep away from</h3>' +
      '<ul>' +
      '<li><strong>Bleach and chlorine</strong> — the fastest way to permanently discolour plating.</li>' +
      '<li><strong>Alcohol-based hand sanitiser</strong> — strips the finish over time; let it dry fully before touching your rings.</li>' +
      '<li><strong>Household cleaners and detergents</strong> — wear gloves, or take the jewellery off.</li>' +
      '<li><strong>Jewellery "dip" cleaners and silver polish</strong> — these are formulated to strip a micro-layer of metal. On plated jewellery they strip the plating itself. Never use them on ARC pieces.</li>' +
      '<li><strong>Toothpaste, baking soda, vinegar</strong> — popular internet hacks, all abrasive or acidic. They will scratch and dull the finish.</li>' +
      '</ul>' +

      '<h3>Heat and sunlight</h3>' +
      '<p>Avoid leaving pieces on a sunny windowsill, in a hot car, or near a radiator. Sustained heat and direct UV can fade coloured stones, dry out any adhesive in a setting, and dull enamel and pearls.</p>' +

      '<h2>Cleaning</h2>' +
      '<p>For everyday freshening, the dry cloth is all you need. If a piece has become genuinely grubby, do this — gently, and no more than occasionally:</p>' +
      steps([
        ['Mix a mild bath', 'A small bowl of lukewarm water with a single drop of gentle, pH-neutral soap. Never hot water.'],
        ['Dip, do not soak', 'Briefly dip the piece, or dampen a soft cloth and wipe it. Do not leave jewellery sitting in liquid.'],
        ['Use a soft brush for detail', 'A baby toothbrush or soft makeup brush, worked lightly around settings and chain links. No pressure.'],
        ['Rinse briefly', 'A quick pass under lukewarm water to remove any soap residue.'],
        ['Dry completely', 'Pat with a soft cloth, then leave it out on a towel until it is bone dry. Trapped moisture is what causes tarnish, so this step matters more than any of the others.']
      ]) +
      '<p>Never use ultrasonic cleaners, steam cleaners, abrasive sponges, tissue or paper towel (which is more abrasive than it feels), or any chemical polish.</p>' +

      '<h2>Storage</h2>' +
      '<p>Most damage happens when jewellery is not being worn. Pieces thrown together in a dish scratch each other, chains knot, and humidity does its quiet work.</p>' +
      '<ul>' +
      '<li><strong>Separately, always.</strong> Each piece in its own pouch or a lined compartment. Metal against metal is how scratches happen.</li>' +
      '<li><strong>Cool, dry and dark.</strong> A drawer or box beats an open tray in a steamy bathroom.</li>' +
      '<li><strong>Fasten chains before storing.</strong> A clasped necklace laid flat will not tangle; an open one always finds a way.</li>' +
      '<li><strong>Keep the pouch we sent.</strong> It is not packaging, it is the storage the piece is designed for.</li>' +
      '<li><strong>Add a silica gel sachet</strong> to your jewellery box if you live somewhere humid or coastal — it costs nothing and absorbs the moisture that causes tarnish.</li>' +
      '</ul>' +

      '<h2>Handling</h2>' +
      '<p>Hold rings by the band rather than the stone, and lift necklaces by the clasp rather than the pendant. Fasten and unfasten clasps properly instead of stretching pieces over your head — most broken chains break at the join, from being pulled.</p>' +
      '<p>Earring backs loosen with use. Give them an occasional gentle squeeze so they grip properly, and check the posts every so often.</p>' +

      '<h2>By Material</h2>' +

      '<h3>Gold and rose gold plated</h3>' +
      '<p>The finish is the piece. Keep it away from abrasives and polish cloths marketed for solid gold — they are designed to remove metal. A dry, soft cloth is the only tool a plated piece ever needs.</p>' +

      '<h3>Silver finishes</h3>' +
      '<p>Silver naturally reacts with sulphur in the air, which is what causes darkening. Our anti-tarnish coating slows this dramatically, but storage in a dry, closed box — ideally with an anti-tarnish strip — is what keeps it bright long-term.</p>' +

      '<h3>Stones, crystals and pearls</h3>' +
      '<p>These are the most delicate elements on any piece. Never soak them: water can seep behind a setting and weaken the adhesive, and pearls in particular are porous and will lose their lustre. Wipe stones with a barely damp cloth and dry immediately. Pearls should only ever be wiped with a dry, soft cloth.</p>' +

      '<h3>Enamel and resin</h3>' +
      '<p>Sensitive to heat and solvents. Keep away from perfume, nail polish remover and direct sun, and never use a brush on them.</p>' +

      '<h2>What to Expect Over Time</h2>' +
      '<p>We would rather be straight with you than oversell. Anti-tarnish plating is a genuine, meaningful upgrade over standard fashion jewellery — but it is not indestructible, and no plated jewellery on earth is permanent.</p>' +
      '<p>Worn daily and cared for well, an ARC piece should hold its finish beautifully for a long time. Worn in the shower, slept in, and stored in a heap, any plated piece will fade faster. The variable is almost never the jewellery — it is the habits around it.</p>' +
      '<p>Very fine surface marks on rings and bracelets are normal and unavoidable; they are the parts that meet desks, keys and door handles all day. This is wear, not a fault, and it is the sign of a piece that is actually being enjoyed.</p>' +

      '<h2>Quick Reference</h2>' +
      '<h3>Do</h3>' +
      '<ul>' +
      '<li>Put jewellery on last, take it off first.</li>' +
      '<li>Wipe with a dry, soft cloth after every wear.</li>' +
      '<li>Store pieces separately, dry, and out of the light.</li>' +
      '<li>Remove before swimming, showering, exercising and sleeping.</li>' +
      '</ul>' +
      '<h3>Do not</h3>' +
      '<ul>' +
      '<li>Spray perfume or sanitiser onto or over your jewellery.</li>' +
      '<li>Use polish, dips, toothpaste, baking soda or ultrasonic cleaners.</li>' +
      '<li>Soak anything with stones or pearls.</li>' +
      '<li>Leave pieces jumbled together in a bowl or bag.</li>' +
      '</ul>' +

      '<h2>Still Not Sure?</h2>' +
      '<p>If a piece is not behaving the way you expect, talk to us before you try to fix it yourself — most of the damage we see comes from well-meant home remedies. Email ' + mail + ' or call ' + tel + ' and we will tell you honestly what can and cannot be done.</p>' +

      '</div>' +
      foot(
        ['Your ARC jewellery is made to be worn, loved, gifted and kept.'],
        'Wear it with confidence. Care for it with love.'
      )
  };

  /* =============================== FAQ =============================== */
  pages['faq'] = {
    title: 'Frequently Asked Questions',
    html:
      crumb('FAQ') +
      head(
        'Help centre',
        'Frequently Asked Questions',
        'Everything about our materials, orders, shipping, returns and care — in one place. If your question is not here, we are a message away.'
      ) +
      '<div class="arc-doc-body">' +
      '<div class="arc-faq">' +
      faq([
        { group: 'Products & Materials' },
        {
          q: 'What are your pieces made of?',
          a: '<p>ARC jewellery is crafted from high-quality base alloys finished with premium plating — 18K gold, rose gold, and sterling silver tones. Every piece carries an anti-tarnish, water-resistant coating.</p>' +
             '<p>All our jewellery is <strong>nickel-free and lead-free</strong>, which is what makes it safe for the vast majority of sensitive skin.</p>'
        },
        {
          q: 'Is ARC jewellery suitable for sensitive skin?',
          a: '<p>Yes. Every piece is hypoallergenic, nickel-free and lead-free, and the anti-tarnish coating adds a further barrier between the metal and your skin.</p>' +
             '<p>Nickel is the cause of the overwhelming majority of jewellery reactions, so removing it solves the problem for almost everyone. If you have a diagnosed metal allergy or a history of reacting even to hypoallergenic jewellery, please reach out before ordering and we will talk you through the specific piece.</p>'
        },
        {
          q: 'Will it turn my skin green, or fade?',
          a: '<p>It should not. Green marks are a reaction to copper in unsealed alloys, and our anti-tarnish coating is specifically there to prevent skin contact with the base metal.</p>' +
             '<p>That said, plating is a surface and it responds to how it is treated. Worn sensibly — off before showering, swimming and sleeping, wiped down after wear — a piece will hold its finish for a long time. Worn constantly in water and perfume, any plated jewellery will fade faster. Our <a href="/pages/care-guide">Care Guide</a> covers this in full.</p>'
        },
        {
          q: 'Is it real gold or silver?',
          a: '<p>Our pieces are <strong>plated</strong>, not solid gold or solid silver. That is a deliberate choice: it is what lets us offer designs at this level of finish at a price that makes sense for everyday wear.</p>' +
             '<p>We would rather tell you that plainly than dress it up. What you are buying is a well-made, anti-tarnish, skin-safe piece designed to be worn every day — not an investment metal.</p>'
        },
        {
          q: 'Is it waterproof?',
          a: '<p>Water-<em>resistant</em>, which is not quite the same thing. Splashes, hand-washing and rain are completely fine.</p>' +
             '<p>What we would avoid is prolonged immersion — showers, swimming pools, the sea. It is not really the water, it is the chlorine, salt and soap dissolved in it. Water resistance means your jewellery survives accidents; it is not an invitation to swim in it.</p>'
        },
        {
          q: 'Do you offer a warranty?',
          a: '<p>Every piece is covered against manufacturing defects — a faulty clasp, a stone that was not set properly, plating that fails abnormally early despite correct care.</p>' +
             '<p>Normal wear and tear, accidental damage, and damage from chemicals, water or improper storage are not covered. If something seems wrong with your piece, email us photographs at ' + mail + ' and we will assess it honestly.</p>'
        },

        { group: 'Orders' },
        {
          q: 'How do I know my order went through?',
          a: '<p>You will receive a confirmation email immediately after checkout, with your order number and a summary. If it has not arrived within a few minutes, check your spam folder before assuming the order failed — and if there is still nothing, contact us with the email address you used rather than placing a second order.</p>'
        },
        {
          q: 'Can I change or cancel my order?',
          a: '<p>Yes, if you are quick. Orders can be amended or cancelled <strong>before they are dispatched</strong> — in practice, that usually means within a few hours of placing them.</p>' +
             '<p>Email ' + mail + ' or call ' + tel + ' with your order number as soon as you can. Once a parcel is with the courier we cannot recall it, and you would need to go through the returns process instead.</p>'
        },
        {
          q: 'What payment methods do you accept?',
          a: '<p>All major credit and debit cards, UPI, net banking, and the usual wallets — everything offered at checkout. All prices are in INR and inclusive of taxes.</p>'
        },
        {
          q: 'Do you take Cash on Delivery?',
          a: '<p>COD availability depends on your pincode and is shown at checkout. If you do not see it as an option, it is not serviceable to your area.</p>'
        },

        { group: 'Shipping' },
        {
          q: 'How much is shipping?',
          a: '<p><strong>Free on all orders above ₹499.</strong> Below that, a flat shipping charge is calculated and shown at checkout before you pay.</p>'
        },
        {
          q: 'When will my order arrive?',
          a: '<p>Orders are dispatched within <strong>24–48 hours</strong>. After that, delivery typically takes 2–4 business days in metros and 4–7 across the rest of India.</p>' +
             '<p>Full timelines are in our <a href="/pages/shipping-policy">Shipping Policy</a>.</p>'
        },
        {
          q: 'How do I track my parcel?',
          a: '<p>As soon as your order ships, we email you a tracking link. Tracking can take up to 24 hours to start updating after you receive it — that is the courier scanning the parcel into their network, and it is normal.</p>'
        },
        {
          q: 'Do you ship internationally?',
          a: '<p>Not at the moment. We currently ship across India only. We would rather do one thing properly than ship badly to everywhere.</p>'
        },

        { group: 'Returns & Exchanges' },
        {
          q: 'What is your return policy?',
          a: '<p>We offer a <strong>' + RETURN_DAYS + '-day return and exchange window</strong>, counted from the date your order is delivered.</p>' +
             '<p>Items must be unused, unworn, and returned in their original packaging with all tags intact. To start a return, email ' + mail + ' with your order number within those ' + RETURN_DAYS + ' days.</p>' +
             '<p>The full terms are in our <a href="/pages/returns-policy">Returns Policy</a>.</p>'
        },
        {
          q: 'Why only ' + RETURN_DAYS + ' days?',
          a: '<p>Because jewellery is worn against skin, and a short, clearly-stated window is what lets us guarantee that every piece we send out is genuinely unworn.</p>' +
             '<p>' + RETURN_DAYS + ' days is enough time to open the parcel, try the piece on, and decide — which is what the window is for. Please do check your order promptly on arrival.</p>'
        },
        {
          q: 'My item arrived damaged or is the wrong piece.',
          a: '<p>Then this is on us, and we will fix it. Contact us within <strong>48 hours</strong> of delivery with your order number and photographs of the item and its packaging.</p>' +
             '<p>We will arrange a replacement or a full refund, including any shipping you paid. You will not be charged for return shipping on a fault of ours.</p>'
        },
        {
          q: 'When do I get my refund?',
          a: '<p>Once your return reaches us and passes inspection, refunds are processed within <strong>5–7 business days</strong> to your original payment method. Your bank may take a few days more to show it.</p>'
        },
        {
          q: 'Can I exchange for a different piece?',
          a: '<p>Yes — exchanges follow the same ' + RETURN_DAYS + '-day window and the same condition rules. Subject to stock; if the piece you want is unavailable we will refund you instead.</p>'
        },
        {
          q: 'Are earrings returnable?',
          a: '<p>Unfortunately not. For hygiene reasons, <strong>pierced earrings cannot be returned or exchanged</strong> once the seal is broken — this is standard across the industry and it protects every customer.</p>' +
             '<p>The exception is a genuine manufacturing defect or a wrong item sent, which we will always put right.</p>'
        },

        { group: 'Care' },
        {
          q: 'How should I look after my jewellery?',
          a: '<p>Put it on last and take it off first. Wipe it with a dry, soft cloth after wearing. Store pieces separately, somewhere dry. Keep it away from perfume, sanitiser, chlorine and household cleaners.</p>' +
             '<p>That is most of it. Our <a href="/pages/care-guide">Care Guide</a> has the full detail, including what to do and what never to do.</p>'
        },
        {
          q: 'Can I use a jewellery polish or a cleaning dip?',
          a: '<p><strong>No — please do not.</strong> Polishes, dips and silver cleaners are designed to strip a micro-layer of metal from solid pieces. On plated jewellery they strip the plating itself and will ruin the finish permanently.</p>' +
             '<p>The same goes for toothpaste, baking soda and ultrasonic cleaners. A dry, soft cloth is genuinely all a plated piece ever needs.</p>'
        },
        {
          q: 'My chain is tangled. What do I do?',
          a: '<p>Lay it flat, put a drop of oil on the knot, and work it loose with two pins — patiently, without pulling. Chains almost always break at the join, and they break because someone pulled.</p>'
        },

        { group: 'Still stuck?' },
        {
          q: 'How do I reach a human?',
          a: '<p>Email ' + mail + ' or call ' + tel + '. Have your order number to hand and we will get to you quickly.</p>'
        }
      ]) +
      '</div>' +
      '</div>' +
      foot(['Did not find what you were looking for? Email ' + mail + ' — we answer every message.'])
  };

  /* ========================== SHIPPING POLICY ========================== */
  pages['shipping-policy'] = {
    title: 'Shipping Policy',
    html:
      crumb('Shipping Policy') +
      head(
        'Getting it to you',
        'Shipping Policy',
        'How quickly we dispatch, what it costs, how long delivery takes, and exactly what happens if something goes wrong on the way.'
      ) +
      '<div class="arc-doc-body">' +

      '<h2>At a Glance</h2>' +
      facts([
        ['Free shipping', 'On all orders above ₹499'],
        ['Below ₹499', 'Flat rate, shown at checkout'],
        ['Dispatch time', 'Within 24–48 hours'],
        ['Metro delivery', '2–4 business days'],
        ['Rest of India', '4–7 business days'],
        ['Tracking', 'Emailed on dispatch'],
        ['We ship to', 'India only']
      ]) +

      '<h2>Shipping Charges</h2>' +
      '<p>Shipping is <strong>free on every order above ₹499</strong>. For orders below that, a flat shipping charge applies, and it is always calculated and displayed at checkout before you pay. There are no charges added later, and no surprises at the door.</p>' +
      '<p>All prices on the site are in Indian Rupees and inclusive of applicable taxes.</p>' +

      '<h2>Processing and Dispatch</h2>' +
      '<p>Orders are picked, quality-checked and packed within <strong>24 to 48 hours</strong> of being placed. Every piece is inspected before it goes into the box — that check is why we take a day rather than shipping the same hour.</p>' +
      '<p>Orders placed on Sundays and public holidays are processed on the next working day. During sales, festival periods and new launches, dispatch can take slightly longer; if that is the case, we will say so on the site rather than let you find out by waiting.</p>' +

      '<h2>Delivery Timelines</h2>' +
      '<p>Once dispatched, here is what to expect:</p>' +
      facts([
        ['Metro cities', '2–4 business days'],
        ['Tier-2 cities & towns', '3–5 business days'],
        ['Rest of India', '4–7 business days'],
        ['Remote & hill regions', 'Up to 10 business days']
      ]) +
      '<p>These are business days, and they start from dispatch rather than from when you ordered. They are realistic estimates based on what our couriers actually achieve — not best-case numbers. They are not guarantees, because the last mile is not something we control.</p>' +

      '<h2>Tracking Your Order</h2>' +
      steps([
        ['Order confirmed', 'You receive a confirmation email with your order number, immediately after checkout.'],
        ['Dispatched', 'Within 24–48 hours we email you a tracking link and your courier partner\'s details.'],
        ['In transit', 'Tracking can take up to 24 hours to begin updating. A quiet tracking page in the first day is normal, not a problem.'],
        ['Delivered', 'The courier will usually call before arriving. Please keep your phone reachable.']
      ]) +
      '<p>If your tracking has not moved at all for more than 3 business days, contact us and we will chase the courier on your behalf.</p>' +

      '<h2>Delivery Addresses</h2>' +
      '<p>Please check your address and phone number carefully at checkout. The overwhelming majority of failed deliveries come down to an incomplete address or an unreachable phone number.</p>' +
      '<p>If you spot a mistake, tell us immediately — we can correct an address <strong>before dispatch</strong>. Once a parcel is with the courier, the address is locked and we cannot change it.</p>' +

      '<div class="arc-note">' +
      '<p>If a parcel is returned to us because the address was incorrect or nobody was reachable after repeated attempts, we will contact you to arrange redelivery. Redelivery in that situation is chargeable, because the courier charges us for it.</p>' +
      '</div>' +

      '<h2>Failed Delivery Attempts</h2>' +
      '<p>Couriers typically make up to three attempts before returning a parcel to us. If you know you will not be available, use the courier\'s tracking link to reschedule — it is far easier to move a delivery than to recover a returned one.</p>' +

      '<h2>Damaged or Missing Parcels</h2>' +
      '<p>If your parcel arrives visibly damaged, tampered with, or looks like it has been opened, <strong>please refuse the delivery</strong> and tell us the same day. That is by far the cleanest outcome for you.</p>' +
      '<p>If you have already accepted it and then find damage inside, contact us within <strong>48 hours</strong> of delivery with photographs of the item, the box and the shipping label. We will send a replacement or refund you in full, including shipping. A courier\'s mistake is not going to become your cost.</p>' +
      '<p>We strongly recommend filming yourself opening the parcel. It is the single most useful thing you can have if anything is wrong, and it makes any claim immediate rather than a discussion.</p>' +

      '<h2>Delays Outside Our Control</h2>' +
      '<p>Weather, strikes, regional restrictions, festival backlogs and courier network problems can all slow a parcel down. We will keep you informed if we know your order is affected, and we will keep chasing it — but we cannot guarantee timelines through disruption of that kind.</p>' +

      '<h2>International Shipping</h2>' +
      '<p>We currently ship <strong>within India only</strong>. We would rather do that well than do international badly. If you are outside India and want ARC pieces, email us — if there is enough demand from your country, it moves up our list.</p>' +

      '<h2>Questions About a Delivery</h2>' +
      '<p>Email ' + mail + ' or call ' + tel + ' with your order number, and we will find out exactly where your parcel is.</p>' +

      '</div>' +
      foot(['See also our <a href="/pages/returns-policy">Returns Policy</a> and <a href="/pages/care-guide">Care Guide</a>.'])
  };

  /* =========================== RETURNS POLICY =========================== */
  pages['returns-policy'] = {
    title: 'Returns & Exchanges',
    html:
      crumb('Returns Policy') +
      head(
        'Changed your mind?',
        'Returns &amp; Exchanges',
        'A ' + RETURN_DAYS + '-day return and exchange window from the day your order is delivered. Here is exactly how it works, in plain language.'
      ) +
      '<div class="arc-doc-body">' +

      '<div class="arc-note">' +
      '<p><strong>You have ' + RETURN_DAYS + ' days from delivery</strong> to request a return or exchange. The item must be unused, unworn, and in its original packaging with all tags attached.</p>' +
      '<p>Please open and check your order as soon as it arrives — the window is short, and it starts on the delivery date.</p>' +
      '</div>' +

      '<h2>At a Glance</h2>' +
      facts([
        ['Return window', RETURN_DAYS + ' days from delivery'],
        ['Exchange window', RETURN_DAYS + ' days from delivery'],
        ['Condition', 'Unused, unworn, tags on, original packaging'],
        ['Damaged or wrong item', 'Report within 48 hours'],
        ['Refund processed', '5–7 business days after inspection'],
        ['Pierced earrings', 'Not returnable (hygiene)']
      ]) +

      '<h2>The ' + RETURN_DAYS + '-Day Window</h2>' +
      '<p>Your return window opens the day your order is delivered and closes <strong>' + RETURN_DAYS + ' days later</strong>. Your request must reach us inside those ' + RETURN_DAYS + ' days — the item does not need to be back with us by then, but we do need to have heard from you.</p>' +
      '<p>We keep the window short deliberately. Jewellery is worn against skin, and a tight, clearly-stated window is what allows us to promise every customer that the piece they receive is genuinely unworn. ' + RETURN_DAYS + ' days is enough to open the parcel, try the piece on and decide — which is exactly what it is for.</p>' +
      '<p>Requests made after the window has closed cannot be accepted, so please do check your order promptly.</p>' +

      '<h2>What Can Be Returned</h2>' +
      '<p>To be eligible, an item must come back to us:</p>' +
      '<ul>' +
      '<li><strong>Unused and unworn</strong> — beyond trying it on briefly.</li>' +
      '<li><strong>In original condition</strong> — no scratches, no signs of wear, not altered or resized.</li>' +
      '<li><strong>With all tags attached</strong> and any seals unbroken.</li>' +
      '<li><strong>In its original packaging</strong>, including the box, pouch and any inserts or freebies.</li>' +
      '</ul>' +
      '<p>Anything that comes back worn, damaged, incomplete or without its packaging cannot be accepted, and will be returned to you.</p>' +

      '<h2>What Cannot Be Returned</h2>' +
      '<ul>' +
      '<li><strong>Pierced earrings.</strong> For hygiene reasons these cannot be returned or exchanged once the seal is broken. This is standard across the industry and it exists to protect every customer, including you.</li>' +
      '<li><strong>Customised or personalised pieces</strong>, made specifically for you.</li>' +
      '<li><strong>Sale, clearance and final-sale items</strong>, where marked at the time of purchase.</li>' +
      '<li><strong>Gift cards.</strong></li>' +
      '<li><strong>Items damaged by use</strong> — including damage from water, perfume, chemicals, impact or improper storage.</li>' +
      '<li><strong>Items returned without tags or original packaging.</strong></li>' +
      '</ul>' +
      '<p>The one thing that overrides all of the above is a <strong>genuine manufacturing defect or a wrong item sent</strong>. We will always put that right, whatever the category.</p>' +

      '<h2>How to Start a Return</h2>' +
      steps([
        ['Contact us within ' + RETURN_DAYS + ' days', 'Email ' + mail + ' or call ' + tel + '. Include your order number, the item, and the reason for the return.'],
        ['Send a photograph', 'A clear photo of the item and its packaging. This lets us approve most returns immediately, without sending anything back and forth.'],
        ['We confirm and arrange pickup', 'Once approved, we will arrange a reverse pickup where your pincode allows it, or share a return address if it does not.'],
        ['Pack it properly', 'Original box, pouch, tags and inserts. Pack it as carefully as we packed it — items damaged on the way back to us cannot be refunded.'],
        ['We inspect it', 'Within 48 hours of your return arriving, we check the item against the conditions above and email you the outcome either way.'],
        ['Refund issued', 'Approved refunds go back to your original payment method within 5–7 business days.']
      ]) +

      '<h2>Refunds</h2>' +
      '<p>Once your return arrives and passes inspection, we email you to confirm. Approved refunds are processed within <strong>5–7 business days</strong> to the original payment method — we cannot refund to a different card or account.</p>' +
      '<p>Your bank or card issuer may take a few additional days to reflect the credit. That part is out of our hands, but if it has been more than 10 business days since we confirmed your refund and you still cannot see it, contact us and we will send you the transaction reference to take to your bank.</p>' +
      '<p>Prepaid orders are refunded to source. For Cash on Delivery orders, we will collect your bank details to process a direct transfer.</p>' +

      '<div class="arc-note">' +
      '<p>If your order qualified for free shipping only because of the item you are returning, the original shipping cost may be deducted from your refund. We will always tell you the exact figure before we process it.</p>' +
      '</div>' +

      '<h2>Exchanges</h2>' +
      '<p>Exchanges follow the same ' + RETURN_DAYS + '-day window and the same condition requirements. Tell us which piece you would like instead, and provided it is in stock we will ship the replacement as soon as your original item reaches us and passes inspection.</p>' +
      '<p>If the piece you want is out of stock, we will refund you in full rather than leave you waiting. If there is a price difference, we will either collect it or refund it before shipping.</p>' +

      '<h2>Damaged, Faulty or Wrong Items</h2>' +
      '<p>If we sent you the wrong piece, or your item arrived damaged or defective, this is our mistake and we will carry the cost of fixing it.</p>' +
      '<p>Contact us within <strong>48 hours</strong> of delivery with your order number and photographs of the item, the packaging and the shipping label. We will send a replacement or refund you in full, including any shipping you paid. You will never pay return shipping on a fault of ours.</p>' +
      '<p>We strongly recommend filming yourself opening the parcel. It turns any claim into a thirty-second conversation instead of a discussion.</p>' +

      '<h2>Cancellations</h2>' +
      '<p>Orders can be cancelled free of charge <strong>any time before dispatch</strong> — usually a window of a few hours. Email or call us with your order number as quickly as you can and we will stop the parcel and refund you in full.</p>' +
      '<p>Once an order has been handed to the courier we cannot recall it, and you would need to use the returns process above instead.</p>' +

      '<h2>Talk to Us</h2>' +
      '<p>If something is not right with your order, tell us. We would far rather hear about it and fix it than have you quietly disappointed.</p>' +
      '<p>Email ' + mail + ' or call ' + tel + '.</p>' +

      '</div>' +
      foot(
        ['See also our <a href="/pages/shipping-policy">Shipping Policy</a> and <a href="/pages/faq">FAQ</a>.'],
        'Buy it because you love it. If you do not, send it back.'
      )
  };

  /* ===================== unchanged supporting pages ===================== */

  pages['about-us'] = {
    title: 'About Us',
    html:
      crumb('About Us') +
      head('Our story', 'About ARC', 'Anti-tarnish jewellery and accessories for everyday wear. Bold, effortless, and made to last.') +
      '<div class="arc-doc-body">' +
      '<p>ARC creates anti-tarnish jewellery and fashion accessories designed for everyday wear — pieces built for long-lasting shine, skin-friendly comfort, and easy daily styling.</p>' +
      '<p>Every piece is crafted with care, using premium materials and finishes that resist tarnishing, so your jewellery stays as brilliant as the day it arrived. We believe style should never come at the cost of comfort, which is why everything we make is hypoallergenic and nickel-free.</p>' +
      '<p>From statement earrings to delicate bracelets, our collections are designed for people who want quality and design without a luxury price tag.</p>' +
      '<p>Questions? Email ' + mail + ' or call ' + tel + '.</p>' +
      '</div>'
  };

  pages['privacy-policy'] = {
    title: 'Privacy Policy',
    html:
      crumb('Privacy Policy') +
      head('Your data', 'Privacy Policy', 'What we collect, why we collect it, and what we will never do with it.') +
      '<div class="arc-doc-body">' +
      '<p>ARC values your privacy. We collect only the information necessary to process your orders and improve your experience.</p>' +
      '<h2>What We Collect</h2>' +
      '<p>Your name, email address, shipping address, phone number, payment information, and basic browsing behaviour on our site.</p>' +
      '<h2>How We Use It</h2>' +
      '<p>To process and deliver your orders, send you order updates, improve our products and site, and — only with your consent — send you promotional offers.</p>' +
      '<h2>Data Protection</h2>' +
      '<p>We use industry-standard security measures to protect your information. <strong>We do not sell or share your personal data with third parties</strong> for marketing purposes.</p>' +
      '<h2>Contact</h2>' +
      '<p>For any privacy question, or to request deletion of your data, email ' + mail + '.</p>' +
      '</div>'
  };

  pages['terms-of-service'] = {
    title: 'Terms of Service',
    html:
      crumb('Terms of Service') +
      head('The fine print', 'Terms of Service', 'The terms you agree to when you use our site and buy our products.') +
      '<div class="arc-doc-body">' +
      '<p>By using this website and purchasing our products, you agree to the following terms.</p>' +
      '<h2>Products</h2>' +
      '<p>All products are subject to availability. Colours may vary slightly from the images on screen, depending on your display.</p>' +
      '<h2>Pricing</h2>' +
      '<p>All prices are in INR and inclusive of applicable taxes. Prices are subject to change without notice.</p>' +
      '<h2>Returns</h2>' +
      '<p>Purchases are covered by our <a href="/pages/returns-policy">' + RETURN_DAYS + '-day returns policy</a>.</p>' +
      '<h2>Intellectual Property</h2>' +
      '<p>All content on this site is the property of ARC and may not be reproduced without permission.</p>' +
      '<h2>Contact</h2>' +
      '<p>Email ' + mail + ' or call ' + tel + '.</p>' +
      '</div>'
  };

  /* ---------- render ---------- */

  var page = pages[match[1].toLowerCase()];
  if (!page) return;

  // If this handle exists as a real Shopify page, the template renders it server-side
  // and marks it. Never clobber real content with our fallback copy.
  if (document.querySelector('[data-arc-server-page]')) return;

  var main = document.getElementById('main');
  if (!main) return;

  // Clear any inline sizing a previous render may have set; .arc-doc centres itself.
  main.style.paddingTop = '';
  main.style.maxWidth = '';
  main.innerHTML = '<article class="arc-doc">' + page.html + '</article>';

  document.title = page.title + ' — ARC';
  window.scrollTo(0, 0);
})();
